import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { useWeb3React } from "@web3-react/core";
import { ethers } from "ethers";
import { formatEther } from "@ethersproject/units";

import { Field, Form, Formik } from "formik";

import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Input from "@mui/material/Input";
import { Row, Col, Button, Label, Card, CardBody } from "reactstrap";

import {
	pinFileIPFS,
	pinJSONIPFS,
	useMasterContractFormData,
} from "../../../hooks";
import {
	ACTION_UPLOAD_TMP_DELETE,
	tmpDelete,
	tmpUpload,
} from "../../../store/actions/tmpUpload";

import {
	saveMasterContract,
	setDeprecatedContract,
} from "../../../store/actions/admin";
import ContractModal from "../../contract/ContractModal";
import collectionIcon from "../../../assets/img/collection.png";
import toast from "react-hot-toast";

const AdminMasterContractDeploy = () => {
	const { contractType, contractId } = useParams();
	const { account, library, chainId } = useWeb3React();
	const history = useHistory();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.user);
	const { image } = useSelector((state) => state.tmpUpload);
	const upgradableContract = useSelector((state) =>
		state.admin.masterContracts.find((i) => i._id === contractId)
	);
	const { formFieldsData, getInitialValues, schema } =
		useMasterContractFormData(contractType, contractId, upgradableContract);

	const [signer, setSigner] = useState();
	const [show, setShow] = useState(false);
	const [stage, setStage] = useState("none");
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!!account && !!library) {
			setSigner(library.getSigner());
		}
		return () => {
			dispatch({ type: ACTION_UPLOAD_TMP_DELETE });
		};
	}, [account, library, chainId, dispatch]);

	const ImageCollection = styled("input")({
		display: "none",
	});

	const hideModal = () =>
		new Promise((resolve) => {
			setTimeout(() => {
				setShow(false);
				setStage("none");
				setError(null);
				resolve();
			}, 3000);
		});

	const handlUploadImg = (event) => {
		let file = event.target.files[0];
		dispatch(tmpUpload(file));
	};
	const onFormSubmit = async (data) => {
		console.log("data", data);
		if (!upgradableContract && !image?.name) {
			return toast.error("Need add Master Contract image!");
		}
		setShow(true);
		setStage("read");

		let metadata = { ...data };
		delete metadata.abi;
		delete metadata.bytecode;
		metadata.fee_recipient = "";
		metadata.external_link = "";

		async function hashCreator(jsonData) {
			if (upgradableContract && !image?.name) {
				data.image = upgradableContract.image;
				jsonData.image = "ipfs://ipfs/" + upgradableContract.image;
			} else {
				const { imageHash } = await pinFileIPFS(image.name, null, null);
				data.image = imageHash;
				jsonData.image = "ipfs://ipfs/" + imageHash;
			}
			const hashMeta = await pinJSONIPFS(jsonData);
			return hashMeta;
		}

		let contract;

		const { type: contractType } = data;

		try {
			if (
				contractType === "ERC721" ||
				contractType === "ERC721A" ||
				contractType === "ERC721PSI" ||
				contractType === "ERC1155" ||
				contractType === "ERC20" ||
				upgradableContract
			) {
				const factory = new ethers.ContractFactory(
					JSON.parse(data.abi),
					data.bytecode,
					signer
				);
				const hashMetaContract = await hashCreator(metadata);
				data.meta = hashMetaContract;
				setStage("sign");

				contract = await factory.deploy().catch(() => {
					return null;
				});

				if (contract === null) {
					await hideModal();
					return;
				}
			} else if (
				contractType === "ERC721UPG" ||
				contractType === "ERC1155UPG"
			) {
			}
			setStage("deploy");

			const depcontract = await contract.deployTransaction.wait();
			data.address = contract.address;
			data.type = upgradableContract?.type ?? contractType;
			data.adminId = user._id;
			data.owner = user.account;
			data.chain = chainId;
			data.allowedUser = upgradableContract?.allowedUser || [];
			data.gas = (
				depcontract.effectiveGasPrice.toNumber() *
				parseFloat(formatEther(depcontract.gasUsed._hex))
			).toFixed(8);

			await contract.deployed();
			if (upgradableContract) {
				dispatch(setDeprecatedContract(upgradableContract._id));
			}
			dispatch(saveMasterContract(data));
			setStage("done");
			await hideModal();
			history.replace(`/administration/contracts`);
		} catch (error) {
			setError({ message: error.message });
			await hideModal();
		} finally {
			// if (image?.name) {
			// 	dispatch(tmpDelete(image.name));
			// }
		}
	};

	return (
		<>
			<Card>
				<CardBody>
					<Row>
						<Col md={3} className="user-avatar-section me-3">
							<div className="d-flex align-items-center flex-column">
								<img
									height="200"
									width="200"
									alt="user-avatar"
									src={
										image.name
											? `${process.env.REACT_APP_API_DO_URL}/${image.name}`
											: upgradableContract?.image || collectionIcon
									}
									className="img-fluid mb-2"
									style={{ borderRadius: "16px" }}
								/>
							</div>
						</Col>
						<Col>
							{!contractId ? (
								<h1>{`Deploy master contract ${contractType}`}</h1>
							) : (
								<>
									<h1>{`Upgrade ${upgradableContract.name}`}</h1>
									<h3>{`version: ${upgradableContract.version}`}</h3>
								</>
							)}
							<div>
								<ImageCollection
									accept="image/*"
									id="icon-button-file"
									type="file"
									onChange={handlUploadImg}
								/>
								<Label for="icon-button-file">
									<Button
										color="primary"
										aria-label="upload picture"
										tag="span"
									>
										Choose file
									</Button>
								</Label>
								<p>Upload an image of at least 400x400</p>
							</div>
						</Col>
					</Row>
					<Row>
						<Formik
							initialValues={getInitialValues()}
							validateOnBlur
							enableReinitialize={true}
							validationSchema={schema}
							onSubmit={onFormSubmit}
						>
							<Form sx={{ width: "100%" }}>
								<Row className="gy-1 pt-75">
									<Col md={6} xs={12}>
										<Field name="version" type="text">
											{({ field, meta }) => (
												<div
													style={{
														minWidth: "20%",
														paddingRight: "1rem",
														marginBottom: "2rem",
													}}
												>
													<Label className="form-label" for="version">
														Contract's version
													</Label>
													<Input
														{...field}
														id="version"
														inputComponent="input"
														variant="standard"
														fullWidth
														readOnly
													/>
													{meta.touched && meta.error && (
														<div
															className="field-tip"
															style={{
																color: "red",
															}}
														>
															{meta.error}
														</div>
													)}
													<span className="field-tip">
														The contract version is generated automatically
													</span>
												</div>
											)}
										</Field>
									</Col>
								</Row>
								<Row className="gy-1 pt-75">
									{formFieldsData.map((formField) => (
										<Col key={formField.id} md={6} xs={12}>
											<Field name={formField.name} type={formField.type}>
												{({ field, meta }) => (
													<div
														style={{
															minWidth: "20%",
															paddingRight: "1rem",
															marginBottom: "2rem",
														}}
													>
														<Label className="form-label" for={formField.id}>
															{formField.label}
														</Label>
														<Input
															{...field}
															{...(formField.input ?? [])}
															id={formField.id}
															// type={formField.type}
															inputComponent="input"
															variant="standard"
															fullWidth
														/>
														{meta.touched && meta.error && (
															<div
																className="field-tip"
																style={{
																	color: "red",
																}}
															>
																{meta.error}
															</div>
														)}
														{formField.tip && (
															<span className="field-tip">{formField.tip}</span>
														)}
													</div>
												)}
											</Field>
										</Col>
									))}
									<Col md={12} xs={12}>
										<Field name="abi" type="text">
											{({ field, meta }) => (
												<div
													style={{
														minWidth: "20%",
														paddingRight: "1rem",
														marginBottom: "2rem",
													}}
												>
													<TextField
														{...field}
														id="abi"
														label="Abi"
														multiline
														minRows={4}
														maxRows={10}
														fullWidth
													/>
													{meta.touched && meta.error && (
														<div
															className="field-tip"
															style={{
																color: "red",
															}}
														>
															{meta.error}
														</div>
													)}
													<span className="field-tip">
														Copy and past from JSON
													</span>
												</div>
											)}
										</Field>
									</Col>
									<Col md={12} xs={12}>
										<Field name="bytecode" type="text">
											{({ field, meta }) => (
												<div
													style={{
														minWidth: "20%",
														paddingRight: "1rem",
														marginBottom: "2rem",
													}}
												>
													<TextField
														{...field}
														id="bytecode"
														label="Bytecode"
														multiline
														minRows={4}
														maxRows={10}
														fullWidth
													/>
													{meta.touched && meta.error && (
														<div
															className="field-tip"
															style={{
																color: "red",
															}}
														>
															{meta.error}
														</div>
													)}
													<span className="field-tip">
														Copy and past from JSON
													</span>
												</div>
											)}
										</Field>
									</Col>
								</Row>
								<Box
									sx={{
										display: "flex",
										gap: "2rem",
										flexWrap: "nowrap",
									}}
								></Box>
								<Box
									sx={{
										padding: "1.5rem",
										width: "100%",
										textAlign: "end",
									}}
								>
									{!account ? (
										<p>Please connect wallet to create collection</p>
									) : (
										<Button type="submit" color="primary" className="px-4">
											Deploy Contract
										</Button>
									)}
								</Box>
							</Form>
						</Formik>
					</Row>
				</CardBody>
			</Card>
			<ContractModal show={show} stage={stage} error={error} />
		</>
	);
};

// export default withRouter(AdminMasterContractDeploy);
export default AdminMasterContractDeploy;
